var APIURL = {
  test: {
    list: '',
    add: '',
    update: '',
    delete: '',
    info: ''
  },
  account: {
    password: {
      update: '/user/pwd',
      reset: '/sysUser'
    },
    user: {
      update: '/sysUser/profile',
      info: '/user/profile'
    },
    status: {
      update: '/sysUser'
    },
    userTemplate: {
      download: '/sysUser/importTemplate'
    }
  },
  alarm: {
    // 告警
    list: '/alarm/list',
    add: '/alarm/add',
    update: '/alarm/update',
    info: '/alarm/info'
  },
  alarmSet: {
    // 告警设置
    list: '/alarm/setList',
    add: '/alarm/addSet',
    update: '/alarm/updateSet',
    delete: '/alarm/delData'
  },
  dispatch: {
    list: '/dispatch/myDispatchList',
    add: '/dispatch/addDistributeLeaflets',
    update: '/dispatch/updateDistributeLeaflets',
    delete: '/policy/delData',
    info: '/policy/getData'
  },
  energy: {
    list: '/energy/notice/list',
    info: '/energy/notice/info',
    update: '/energy/notice/update'
  },
  heart: {
    send: {
      all: '/sendHeartAll',
      one: '/sendHeartByTerminalId/'
    },
    single: {
      list: '/rdcsm/heartList',
      info: '/rdcsm/heartInfo'
    },
    integrate: {
      list: '/heartList',
      info: '/heartInfo'
    }
  },
  heartLog: {
    single: {
      list: '/rdcsm/hearttestLog',
      info: '/rdcsm/hearttestLogInfo'
    },
    integrate: {
      list: '/hearttestLog',
      info: '/hearttestLogInfo'
    }
  },
  policy: {
    list: '/policy/pageList',
    add: '/policy/addData',
    update: '/policy/updateData',
    delete: '/policy/delData',
    info: '/policy/getData'
  },
  policyTemplate: {
    rdcsm: {
      list: '/policy/template/list/rdcsm',
      add: '/policy/template/add/rdcsm',
      update: '/policy/template/modify/rdcsm',
      delete: '/policy/template/delete/rdcsm',
      info: '/policy/template/info/rdcsm'
    },
    rdc4m: {
      list: '/policy/template/list/rdc4m',
      add: '/policy/template/add/rdc4m',
      update: '/policy/template/modify/rdc4m',
      delete: '/policy/template/delete/rdc4m',
      info: '/policy/template/info/rdc4m'
    }
  },
  qr: {
    login: {
      auth: '/api/wx/pc/login/oauth'
    },
    web: {
      access_token: '/api/wx/pc/accesstoken/code',
      refresh_token: '',
      qr_buiduser: '/api/wx/pc/binduser'
    }
  },
  query: {
    terminal: '/query/terminals',
    template: '/query/template'
  },
  schedule: {
    list: '/plan/list',
    update: '/plan/add'
  },
  scheduleEmergency: {
    update: '/plan/emergency/add',
    info: '/plan/emergency/query'
  },
  setting: {
    manauto: {
      info: '/queryManautoData'
    }
  },
  sysUser: {
    list: '/sysUserList',
    info: '/sysUser/:userId',
    init: '/sysUser/',
    add: '/sysUser',
    update: '/sysUser',
    delete: '/sysUser/:userId',
    export: '/sysUser/export'
  },
  terminal: {
    list: '/terminalList',
    add: '/addterminal',
    update: '/editterminal',
    delete: '/delterminal',
    info: '/terminalInfo',
    inventory: '/terminal/inventory/list' // 设备库存/设备仓储列表
  },

  user: {
    login: '/api/login',
    //
    logout: '/logout',
    refreshtoken: '/refreshtoken',
    //
    info: '/getinfo',
    captcha: '/getCaptcha'
  },
  userAvatar: {
    upload: '/user/avatar'
  },
  task: {
    exec: {
      rdcsm: {
        relay: '/rdcsm/relayExec/info',
        manauto: '/rdcsm/manautoExec/info'
      },
      rdc4m: {
        relay: '/rdc4m/relayExec/info',
        manauto: '/rdc4m/manautoExec/info'
      }
    }
  },
  quick: {
    rdcsm: {
      relay: '/rdc4m/relay/info',
      manauto: '/rdc4m/manauto/info'
    },
    rdc4m: {
      relay: '/rdc4m/relay/info',
      manauto: '/rdc4m/manauto/info'
    }
  },
  rdc4m: {
    manauto: {
      log: {
        list: '/rdc4m/manautoLog/list',
        info: '/rdc4m/manautoLog/info'
      }
    }
  }
};
export default APIURL;